import React from 'react';

import { ProductType } from 'constants/product';

//
// --- Types ---

interface ProductMatchProps {
  children: React.ReactChild;
  /** ProductSwitch support single product type or an array of product types to match against */
  product: ProductType | ReadonlyArray<ProductType>;
}

//
// --- ProductMatch Component ---

/**
 * Meant to be used as children in `ProductSwitch` components. Requires a
 * `product` prop so it can be used to match against in `ProductSwitch`. This
 * component simply returns its children for rendering purposes
 */
const ProductMatch: React.FC<ProductMatchProps> = ({ children }) => {
  return children as JSX.Element;
};

export default ProductMatch;
